import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface PatientTabsResponse {
  patientTabs: PatientTabsResponse_Tab[];
}

export interface PatientTabsResponse_Tab {
  patient: {
    id: string;
    nameFirst: string;
    nameLast: string;
    dob: string;
  };
  encounter: {
    encounterClass: string;
    id: string;
    condition: string | null;
  } | null;
  sla: {
    patientWaitingSince: string | null;
  } | null;
  tabType: PatientTabType;
  addedAt: string;
}

export enum PatientTabType {
  ASYNC = "async_note",
  MANUALLY_ADDED = "manually_added",
  PREVIEW = "preview", // frontend-only type, see `usePreviewTabs` for more details
  URGENT = "urgent_chat",
}

export const usePatientTabs = (enabled: boolean) => {
  return useApi<PatientTabsResponse>({
    queryOptions: {
      enabled,
      queryFn: async () => {
        const response = await axiosInstance.get<PatientTabsResponse>(
          "/clinic/patient-list/patient-tabs",
        );

        return response.data;
      },
      staleTime: 0,
      gcTime: 0,
      queryKey: QueryKeys.Provider.PATIENT_TABS,
    },
  });
};
